export class Designation {
    id:number;
    name:string;
}
